import React, { useState } from "react";
import ZeplinPanel from "./ZeplinPanel";
import { PATForm } from "./PATForm";
import { isLoggedIn, login, logout } from "../utils/api";
export const MainPanel = ({ zeplinLink }) => {
    const [loggedIn, setLoggedIn] = useState(isLoggedIn());
    if (!loggedIn) {
        return React.createElement(PATForm, { onSubmit: (newToken) => {
                login(newToken);
                setLoggedIn(true);
            } });
    }
    return React.createElement(ZeplinPanel, { zeplinLink: zeplinLink, onLogout: () => {
            logout();
            setLoggedIn(false);
        } });
};
